import {
  StaticNavigationNavigationItemDtoLinkType,
  type StaticApplicationsFooterBffFooterDto,
} from '@ori/static-api-client-react';

import { type FooterContent } from '../models/FooterContent';
import { getChildrenWithNavigationType } from './getChildrenWithNavigationType';
import { getFooterNavigationType } from './getFooterNavigationType';
import { getPaymentMethods } from './getPaymentMethods';
import { type StaticApplicationsFooterBffFooterDtoItem, getSiteLinksColumns } from './getSiteLinksColumns';

export const parseFooterData = (data: StaticApplicationsFooterBffFooterDto): FooterContent => {
  const footer = getFooterNavigationType(data);
  const bottom = getChildrenWithNavigationType(StaticNavigationNavigationItemDtoLinkType.Bottom, footer);
  const paymentMethodsItems = getPaymentMethods(footer);
  const copyright = getChildrenWithNavigationType(StaticNavigationNavigationItemDtoLinkType.BottomCopyright, bottom);
  const links =
    bottom?.children
      .filter((item) => item.linkType === StaticNavigationNavigationItemDtoLinkType.BottomLinks)
      .filter((link): link is StaticApplicationsFooterBffFooterDtoItem => Boolean(link.title)) ?? [];
  const siteLinksColumns = getSiteLinksColumns(footer);
  const ourApps = getChildrenWithNavigationType(StaticNavigationNavigationItemDtoLinkType.OurApps, footer);
  const turkishException = getChildrenWithNavigationType(StaticNavigationNavigationItemDtoLinkType.QRTR, footer);
  const languages = data.languages.map((value) => ({
    code: value.code ?? '',
    name: value.name ?? '',
    type: value.type,
  }));

  return {
    allPagesPagesContent: bottom?.description,
    frontpageContent: bottom?.title,
    paymentMethodsItems,
    copyrightTitle: copyright?.title,
    copyrightLinks: links,
    siteLinksColumns,
    ourApps,
    turkishException,
    languages,
    languageConfiguration: data.application?.footer?.languageConfiguration,
    socialMediaLinks: data.socialMediaLinks,
    newsletterSubsciptionConfiguration: data.newsletterSubsciptionConfiguration,
    mobileApps: data.mobileApps,
  };
};
